import React from 'react';
import ChangeRequestsList from '../../../manager/MyTeam/MyTeamChangeRequests/ChangeRequestsList';
import Loading from '../../../manager/MyTeam/MyTeamChangeRequests/ChangeRequestsList/Loading';
import ServerError from '../../../../../components/ServerError';
import { useMyEmployeeDataChangeRequestsQuery } from '../../../__generated__/graphql';
import PageHeader from '../../PageHeader';
import { useTranslation } from 'react-i18next';
import { useFlairBreadcrumbHook } from '../../../../../hooks/useFlairBreadcrumbHook';

const i18Prefix = 'navigation.menuItems.profile';
const requestFormsKey = `${i18Prefix}.subMenuItems.requestForms.title`;

export const MyEmployeeDataChangeRequests: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { data, loading, error } = useMyEmployeeDataChangeRequestsQuery();

  const { t } = useTranslation();

  useFlairBreadcrumbHook([
    { label: t(`${i18Prefix}.title`) },
    {
      label: t(requestFormsKey),
    },
  ]);

  if (loading) {
    return <Loading />;
  }

  if (error || data === undefined) {
    return <ServerError />;
  }
  const changeRequests = data.me.employeeDataChangeRequests;
  return (
    <>
      <PageHeader title={t(requestFormsKey)}></PageHeader>
      <ChangeRequestsList mode="employee" changeRequests={changeRequests} />
    </>
  );
};
